<template lang="html">
  <div class="content">
    <div class="ai-tabs tabs">
      <div class="search" />
      <div>
        <div v-for="(tab, i) in tabs"
             :key="i"
             class="ai-tabs__tab"
             :class="{'ai-tabs__tab--active': tab.value === activeTab}"
             @click="switchTo(tab.value)">
          {{ tab.name }}
        </div>
      </div>
      <div class="ai-input-group search">
        <input ref="search" type="text"
               class="ai-input ai-input-group__input search__input"
               placeholder="请输入搜索内容" @keyup.enter="seachModel" :value='searchValue'>
        <div class="ai-button ai-input-group__button search__button">
          <i class="material-icons" @click.stop="seachModel">search</i>
        </div>
      </div>
    </div>
    <div class="models">
      <div v-for="(item, index) in models" :key="index" class="model-item">
        <div class="model-item__thumb model-item-thumb">
          <img class="model-item-thumb__image" :src="item.preview_img">
          <div class="model-item-thumb__cover">
            <AiImageButton class="model-item-thumb__button"
                           :idle="icons.preview.idle"
                           :pressed="icons.preview.pressed"
                           @click="veiwModel(item)" />
            <AiImageButton class="model-item-thumb__button"
                           :idle="icons.edit.idle"
                           :pressed="icons.edit.pressed"
                           @click="editModel(item)" />
            <AiImageButton class="model-item-thumb__button"
                           :idle="icons.permissions.idle"
                           :pressed="icons.permissions.pressed"
                           @click="downloadModel(item)" />
            <AiImageButton class="model-item-thumb__button"
                           :idle="icons.remove.idle"
                           :pressed="icons.remove.pressed"
                           @click="showConfirm(item.id)" />
          </div>
        </div>
        <div class="model-item__title">
          {{ item.store_name }} {{ item.floor_nb }} {{ item.location_nb }}
        </div>
        <div class="model-item__sub">
          {{ item.created_at | timeFormatter }} {{ item.mall_name }}
        </div>
        <div class="model-item__sub">
          访问量: {{ item.visit_nb }}
        </div>
      </div>
    </div>
    <AiPagination v-model="currentPage"
                  class="pagination"
                  :total-page-count="totalPageCount"
                  @change="getData" />
  </div>
</template>

<script>
import moment from "moment";

const ICON_PREVIEW = require("@/assets/views/models/preview.svg");
const ICON_PREVIEW_PRESSED = require("@/assets/views/models/preview-selected.svg");
const ICON_EDIT = require("@/assets/views/models/edit.svg");
const ICON_EDIT_PRESSED = require("@/assets/views/models/edit-selected.svg");
const ICON_PERMISSIONS = require("@/assets/views/models/permissions.svg");
const ICON_PERMISSIONS_PRESSED = require("@/assets/views/models/permissions-selected.svg");
const ICON_REMOVE = require("@/assets/views/models/remove.svg");
const ICON_REMOVE_PRESSED = require("@/assets/views/models/remove-selected.svg");

export default {
  filters: {
    timeFormatter(val) {
      return moment(val).format("YYYY-MM-DD HH:mm");
    }
  },
  data() {
    return {
      activeTab: "newly-created",
      tabs: [
        {
          name: "最新创建",
          value: "newly-created"
        },
        {
          name: "最多访问",
          value: "most-viewed"
        },
        {
          name: "最新编辑",
          value: "newly-edited"
        },
        {
          name: "搜索结果",
          value: "search-result"
        }
      ],
      totalPageCount: 20,
      currentPage: 1,
      models: [],
      searchValue: "",
      icons: {
        preview: { idle: ICON_PREVIEW, pressed: ICON_PREVIEW_PRESSED },
        edit: { idle: ICON_EDIT, pressed: ICON_EDIT_PRESSED },
        permissions: {
          idle: ICON_PERMISSIONS,
          pressed: ICON_PERMISSIONS_PRESSED
        },
        remove: { idle: ICON_REMOVE, pressed: ICON_REMOVE_PRESSED }
      }
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getData();
  },
  methods: {
    switchTo(tabValue) {
      this.activeTab = tabValue;
    },
    async getData() {
      if (this.searchValue) this.seachModel();
      else {
        const params = { page_num: this.currentPage };
        try {
          const {
            data: { data }
          } = await this.$http.post("/admin/list-models", params);
          if (data) {
            this.models = data.models;
            // console.log(this.models);
            this.currentPage = data.page_num;
            this.totalPageCount = data.page_count;
          }
        } catch (error) {
          this.$message.basic(error.error_msg);
        }
      }
    },
    async seachModel() {
      this.currentPage =
        this.searchValue !== this.$refs.search.value ? 1 : this.currentPage;
      const params = {
        page_num: this.currentPage,
        keyword: this.$refs.search.value
      };

      this.searchValue = this.$refs.search.value;
      try {
        const {
          data: { data }
        } = await this.$http.post("/admin/search-model", params);

        if (data) {
          this.models = data.models;
          console.log(data.page_count);
          this.currentPage = data.page_num;
          this.totalPageCount = data.page_count;
        }
      } catch (error) {
        this.$message.basic(error.error_msg);
      }
    },
    veiwModel(item) {
      console.log(item);
      if (item.store_name.indexOf("生成失败") !== -1) {
        this.$message("生成失败,无法预览!");
        return;
      }
      if (item.store_name.indexOf("生成中") !== -1) {
        this.$message("生成中,无法预览!");
        return;
      }

      // window.open(
      //   `http://` +
      //     window.location.host.split(":")[0] +
      //     `:8097/store/${item.id}`,
      //   "_blank"
      // );
      window.open(`https://vr.aibee.cn/store/${item.id}`, '_blank');
      //console.log(`http://`+(window.location.host).split(':')[0]+`:8097/store/${item.id}`);
      //window.open(`http://192.168.80.23:8097/store/${item.id}`, '_blank');
      //this.$router.push(`/x/models/${modelId}/view`);
    },
    editModel(item) {
      if (item.store_name.indexOf("生成中") !== -1) {
        this.$message("生成中,无法编辑!");
        return;
      }
      this.$router.push(`/x/models/${item.id}/editor`);
    },
    getIconImg() {},
   async downloadModel(item) {
      console.log();
       const params = { vr_id: item.id };
        try {
          const {
            data: { data }
          } = await this.$http.post("http://192.168.90.101:8098/admin/relocation-task", params);
          if (data) {
           this.$message.basic('重定位任务，成功！');
          }
        } catch (error) {
          this.$message.basic(error.error_msg);
        }
      // this.$router.push(`/x/models/${item.id}/editor/cad-alignmet`);
    },
    showConfirm(id) {
      this.$confirm({
        title: "确认要删除该模型吗?",
        message: "删除后, 该模型将不再显示,也不可编辑!"
      })
        .then(() => {
          this.deleteItem(id);
        })
        .catch(() => {});
    },
    async deleteItem(id) {
      const params = { store_id: id };
      try {
        const { data } = await this.$http.post("/admin/delete-store", params);
        if (data.error_msg === "success") {
          console.log(data);
          this.getData();
        }
      } catch (error) {
        this.$message.basic(error.error_msg);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tabs {
  width: 100%;
  margin-top: 10px;
  justify-content: space-between;
}

.search {
  margin: 0 40px;
  width: 232px;

  .ai-input {
    width: 183px;
    height: 22px;
  }

  .ai-button {
    width: 22px;
    height: 22px;

    .material-icons {
      margin: 0;
      font-size: 14px;
      color: #9e9e9e;
    }
  }
}

.models {
  display: grid;
  grid-template-columns: repeat(4, 320px);
  grid-template-rows: auto;
}

.model-item {
  margin: 20px 40px;
  color: #888;

  &__thumb {
    width: 240px;
    height: 200px;
    background-color: #e0e0e0;
    border-radius: 4px;
    position: relative;
  }

  &__title {
    font-size: 18px;
    margin: 6px 0 2px;
  }

  &__sub {
    font-size: 14px;
    font-weight: 300;
    margin: 2px 0;
  }
}

.model-item-thumb {
  &__image {
    width: 240px;
    height: 200px;
    border-radius: 4px;
    object-fit: cover;
  }

  &__cover {
    position: absolute;
    display: grid;
    width: 232px;
    height: 196px;
    top: 0;
    left: 0;
    padding: 2px 4px;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.6);
    grid-template-columns: 50% 50%;
    grid-template-rows: 50% 50%;
    justify-items: center;
    align-items: center;
    opacity: 0;
    transition: 0.15s;

    &:hover {
      opacity: 1;
    }
  }

  &__button {
    width: 40px;
    height: 40px;
  }
}

.pagination {
  width: 100%;
  margin: 8px 0 38px;
}
</style>
